// extracted by mini-css-extract-plugin
module.exports = {"container":"AppLoader_container__buL0k"};